import React, { useState } from 'react';
import { IconCalculator, IconTrendingDown, IconCheck } from '@tabler/icons-react';
export function SavingsCalculator() {
  const [turnovers, setTurnovers] = useState<number>(20);
  // Cost assumptions
  const standardCostPerTurnover = 45;
  const cleanAiCostPerTurnover = 30;
  const monthlyStandardCost = turnovers * standardCostPerTurnover;
  const monthlyCleanAiCost = turnovers * cleanAiCostPerTurnover;
  const monthlySavings = monthlyStandardCost - monthlyCleanAiCost;
  const yearlySavings = monthlySavings * 12;
  return <section className="w-full bg-white py-20 md:py-24 px-5" data-id="element-192">
      <div className="max-w-6xl mx-auto" data-id="element-193">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-194">
          {/* Left Column: Controls & Copy */}
          <div data-id="element-195">
            <div className="inline-flex items-center gap-2 border border-accent-teal text-navy rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest mb-6" style={{
            backgroundColor: '#FFFFFF'
          }} data-id="element-196">
              <IconCalculator size={16} className="text-accent-teal" data-id="element-197" />
              Calcola il risparmio
            </div>

            <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy mb-4" data-id="element-198">
              Meno spostamenti,
              <br data-id="element-199" />
              <span style={{
              color: '#FF4081'
            }} data-id="element-200">
                più margine per te.
              </span>
            </h2>

            <p className="font-body text-body-gray text-lg mb-8 leading-relaxed" data-id="element-201">
              Usa il simulatore per scoprire quanto puoi risparmiare ogni mese.
              Raggruppando gli interventi nella stessa zona, abbattiamo i costi
              di trasferta e ti garantiamo un prezzo fisso più basso, mantenendo
              la stessa qualità.
            </p>

            <div className="bg-page-bg p-6 md:p-8 rounded-2xl border border-border-light" data-id="element-202">
              <div className="flex justify-between items-end mb-4" data-id="element-203">
                <label htmlFor="turnovers-slider" className="font-heading font-semibold text-navy text-lg" data-id="element-204">
                  Turnover mensili totali
                </label>
                <span className="font-heading font-bold text-3xl text-navy" data-id="element-205">
                  {turnovers}
                </span>
              </div>

              <input id="turnovers-slider" type="range" min="5" max="100" step="5" value={turnovers} onChange={e => setTurnovers(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-accent-pink mb-6" style={{
              accentColor: '#FF4081'
            }} data-id="element-206" />

              <div className="flex justify-between text-sm text-body-gray font-body" data-id="element-207">
                <span data-id="element-208">5 (Piccolo Host)</span>
                <span data-id="element-209">100+ (Property Manager)</span>
              </div>
            </div>
          </div>

          {/* Right Column: Results Card */}
          <div className="bg-navy rounded-none p-8 md:p-10 text-white relative overflow-hidden shadow-2xl" data-id="element-210">
            {/* Decorative background glow */}
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full pointer-events-none opacity-20" style={{
            background: 'radial-gradient(circle, #69ddff 0%, transparent 70%)',
            transform: 'translate(30%, -30%)'
          }} data-id="element-211" />

            <h3 className="font-heading text-xl font-semibold mb-8 text-white/90" data-id="element-212">
              Stima dei costi mensili
            </h3>

            <div className="space-y-6 relative z-10" data-id="element-213">
              {/* Standard Cost */}
              <div className="flex justify-between items-center pb-6 border-b border-white/10" data-id="element-214">
                <div data-id="element-215">
                  <div className="text-white/60 text-sm font-body mb-1" data-id="element-216">
                    Metodo Tradizionale
                  </div>
                  <div className="text-xs text-white/40 font-body" data-id="element-217">
                    ~€45 ad intervento
                  </div>
                </div>
                <div className="font-heading text-2xl text-white/50 line-through decoration-white/30" data-id="element-218">
                  €{monthlyStandardCost.toLocaleString('it-IT')}
                </div>
              </div>

              {/* CleanAI Cost */}
              <div className="flex justify-between items-center pb-6 border-b border-white/10" data-id="element-219">
                <div data-id="element-220">
                  <div className="text-accent-teal font-body font-bold mb-1 flex items-center gap-2 text-[20px]" data-id="element-221">
                    <IconCheck size={16} data-id="element-222" />
                    Con CleanAI
                  </div>
                  <div className="text-xs text-white/60 font-body" data-id="element-223">
                    ~€30 ad intervento (in sharing)
                  </div>
                </div>
                <div className="font-heading text-3xl font-bold text-white" data-id="element-224">
                  €{monthlyCleanAiCost.toLocaleString('it-IT')}
                </div>
              </div>

              {/* Savings Highlight */}
              <div className="pt-4" data-id="element-225">
                <div className="text-white/80 text-sm font-body mb-2" data-id="element-226">
                  Il tuo risparmio stimato
                </div>
                <div className="flex items-baseline gap-3" data-id="element-227">
                  <span className="font-heading text-5xl md:text-6xl font-bold" style={{
                  color: '#FF4081'
                }} data-id="element-228">
                    €{monthlySavings.toLocaleString('it-IT')}
                  </span>
                  <span className="text-white/60 font-body" data-id="element-229">/mese</span>
                </div>

                <div className="mt-4 inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 text-sm font-body text-accent-teal" data-id="element-230">
                  <IconTrendingDown size={18} data-id="element-231" />
                  Risparmi €{yearlySavings.toLocaleString('it-IT')} all'anno
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}